import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setDrawerAlert } from 'slices/drawer'
import { ContextLoader, FaqInputSearch } from 'components'
import { faqService } from 'services'
import { Accordion } from '../accordion'
import { SEARCH_FAQ_ERROR_MESSAGE } from '../../constants'
import './style.scss'

export function FaqSearch({ isFeedbackEnabled }) {
  const [isLoading, setIsLoading] = useState(false)
  const [options, setOptions] = useState([])
  const {
    data: { search = '' },
  } = useSelector(({ drawer }) => drawer)
  const dispatch = useDispatch()
  const { getFaqSearch } = faqService()

  useEffect(() => {
    async function getFaqOptions() {
      try {
        setIsLoading(true)
        const { data } = await getFaqSearch(search)

        setOptions(data)
      } catch (error) {
        console.error(error)

        handleErrorMessage()
      } finally {
        setIsLoading(false)
      }
    }

    if (search) getFaqOptions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search])

  function handleErrorMessage() {
    dispatch(setDrawerAlert({ severity: 'error', title: SEARCH_FAQ_ERROR_MESSAGE }))
  }

  function renderSearchInput() {
    return (
      <div className='search-input-container'>
        <FaqInputSearch
          onError={handleErrorMessage}
          onLoading={() => setIsLoading(true)}
          onLoadingEnd={() => setIsLoading(false)}
        />
      </div>
    )
  }

  function renderSearchResult() {
    if (options.length === 0) {
      return (
        <div className='empty-message-container'>
          Não encontramos nenhuma resposta para a sua dúvida.
        </div>
      )
    }

    return options.map(({ id, question, answer }) => (
      <Accordion
        id={id}
        isFeedbackEnabled={isFeedbackEnabled}
        title={question}
        description={answer}
      />
    ))
  }

  function renderContent() {
    if (isLoading) return <ContextLoader fixed={false} />
    return renderSearchResult()
  }

  return (
    <div className='faq-search-component'>
      <h3 className='title'>Qual a sua dúvida?</h3>
      {renderSearchInput()}
      {renderContent()}
    </div>
  )
}
